import z from "zod";

export const OccurrenceAmenitiesSchema = z.object({
  date: z.string(),
  amenityIds: z.array(z.string()),
  customised: z.boolean(),
});
export type OccurrenceAmenities = z.infer<typeof OccurrenceAmenitiesSchema>;

export const OccurrenceAmenityClashSchema = z.object({
  amenityId: z.string(),
  amenityName: z.string(),
  date: z.string(),
  memberName: z.string().optional(),
});
export type OccurrenceAmenityClash = z.infer<typeof OccurrenceAmenityClashSchema>;
